import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

export function useNetwork() {
  const [isOnline, setIsOnline] = useState(true);
  const [connectionType, setConnectionType] = useState('unknown');

  useEffect(() => {
    const isNative = Capacitor.isNativePlatform();

    if (isNative) {
      let cleanup;
      (async () => {
        const { Network } = await import('@capacitor/network');
        const status = await Network.getStatus();
        setIsOnline(status.connected);
        setConnectionType(status.connectionType);

        const handle = await Network.addListener('networkStatusChange', (s) => {
          setIsOnline(s.connected);
          setConnectionType(s.connectionType);
        });
        cleanup = () => handle.remove();
      })();
      return () => cleanup?.();
    }

    // Web fallback
    setIsOnline(navigator.onLine);
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return { isOnline, connectionType };
}
